<template>
  <div class="root">
    <CountdownBackground />
    <Countdown
      :timeLeft="timeLeft"
      :initialTime="initialTime"
      :tip="currentTip"
    />
  </div>
</template>

<script>
import CountdownBackground from "../components/CountdownBackground";
import Countdown from "../components/Countdown";
import { routesName } from "../router";
export default {
  components: {
    CountdownBackground,
    Countdown,
  },
  data: () => ({
    timeLeft: 0,
    initialTime: 3,
    tips: [
      "Each question has 15 seconds",
      "You have 1 second chance",
      "Each question gives 5 coins",
    ],
  }),
  methods: {
    startCountdown() {
      this.timeLeft = this.initialTime;
      let countdown = setInterval(() => {
        this.timeLeft--;
        if (this.timeLeft < 0) {
          clearInterval(countdown);
          this.startGame();
        }
      }, 1000);
    },
    startGame() {
      this.$router.push(routesName.game);
    },
  },
  computed: {
    currentTip() {
      return "Quick Tip: You get 1 do-over";
    },
  },
  mounted() {
    this.startCountdown();
  },
};
</script>

<style lang="scss" scoped>
@import "../scss/variables.scss";
@import "../scss/common.scss";

@media only screen and (min-width: 600px) {
  .root {
    max-width: 375px;
  }
}

.root {
  min-width: 320px;
  min-height: 570px;
  flex-flow: column;
  justify-content: center;
  align-items: center;
}
</style>
